export const getSiteNavigationElementsSchema = (list: { name: string; url: string; position?: number }[]) => ({
  '@type': 'ItemList',
  itemListElement: [
    list.map(({ name, url, position }, index) => ({
      '@type': 'SiteNavigationElement',
      position: position ?? index + 1,
      name,
      url,
    })),
  ],
});
